var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11302 5.16795C2.28789 4.95336 2.6029 4.92173 2.81662 5.0973L8 9.35542L13.1834 5.0973C13.3971 4.92173 13.7121 4.95336 13.887 5.16795C14.0618 5.38254 14.0303 5.69882 13.8166 5.8744L8.31662 10.3926C8.13244 10.5439 7.86756 10.5439 7.68338 10.3926L2.18338 5.8744C1.96966 5.69882 1.93816 5.38254 2.11302 5.16795Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.5223C0 15.3538 0.671858 16.0284 1.5 16.0284H14.5C15.3281 16.0284 16 15.3538 16 14.5223V3.47775C16 2.64626 15.3281 1.97168 14.5 1.97168H1.5C0.671858 1.97168 0 2.64626 0 3.47775V14.5223ZM15 14.5223C15 14.7993 14.7759 15.0243 14.5 15.0243H1.5C1.22414 15.0243 1 14.7993 1 14.5223V3.47775C1 3.20078 1.22414 2.97573 1.5 2.97573H14.5C14.7759 2.97573 15 3.20078 15 3.47775V14.5223Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.02fe07cc23ab49b4996f70ff65a8207f.svg";
export { ForwardRef as ReactComponent };